import {
    JustpayEquipmentEndpointService
} from "@/views/loyalty/shared/endpoint_services/justpay-equipment-endpoint-service"

export class JustpayEquipmentService {
    constructor () {
        this.justpayEquipmentEndpointService = new JustpayEquipmentEndpointService()
    }

    async getById (equipmentId) {
        const response = await this.justpayEquipmentEndpointService.list({ id: equipmentId })
        if (!response.error) {
            return response.data.length > 0 ? response.data[0] : {}
        }
        return {}
    }

    async getForFiltering () {
        const equipments = await this.justpayEquipmentEndpointService.getForFiltering()
        return equipments || []
    }
}
